import React from "react";

import { SkeletonAvatar, SkeletonBlock } from "./primitives/index";

/**
 * Pagination row skeleton — shown when loading the next page via infinite scroll.
 * Renders a single row matching the common table row structure:
 *   Avatar + 2 text lines (name, subtitle) + wider text blocks
 */
const DataTablePaginationLoader = () => {
  return (
    <div className="DataTablePaginationLoader flex !w-full pr-4 pt-2">
      <div className="skeleton-table-row w-full" style={{ minHeight: 68 }}>
        <SkeletonAvatar size={32} shape="square" />
        <div
          style={{ flex: 1, display: "flex", flexDirection: "column", gap: 6 }}
        >
          <SkeletonBlock width="35%" height={14} radius="sm" />
          <SkeletonBlock width="60%" height={12} radius="sm" />
        </div>
        <SkeletonBlock width="15%" height={14} radius="sm" />
        <SkeletonBlock width="20%" height={14} radius="sm" />
      </div>
    </div>
  );
};

export default DataTablePaginationLoader;
